<template>
	<div id="FooterBox">
		<div style="width: 1100px;margin: 0 auto;">
			<div class="top">
				<div class="left">
					<div class="sub">
						下属子公司 SUBORDINATE SUBSIDIARY COMPANY
					</div>
					<div class="childer">
						<div v-for="(item, index) in dataList" :key="index" class="box_childer">
							<a :href="item.link" target="_blank" :class="item.link ? 'more' : 'more_up'">{{ item.name }}</a>
						</div>

					</div>
				</div>
				<div class="right">
					<div style="margin-right: 20px;">
						<img src="@/assets/image/qrcode.jpg" />
					</div>
					<div>
						<div class="sub">
							联系我们 Contact us
						</div>
						<div>
							<div class="tips">地址：昆山市横长泾路555号蒲公英科创产业园D栋</div>
							<div class="tips">电话：0512-57109888</div>
							<div class="tips">传真：0512-57507967</div>
						</div>
						<!-- <img src="@/assets/image/map.png" /> -->
					</div>
				</div>
			</div>
		</div>
		<div class="bottom">
			Copyright © 2004 - 2024 ksccid.com All Rights Reserved |
			<a class="ba" href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">苏ICP备12034243号-1</a>
		</div>
	</div>
</template>

<script>
import {
	sub
} from '@/api/apis'

export default {
	name: 'Footer',
	props: {
		num: {
			type: Number,
			default: 1
		}
	},
	data() {
		return {
			dataList: [{
				name: '昆山乐成置业有限公司',
				link: 'http://www.kslczy.cn/'
			},
			{
				name: '昆山阳澄湖滨商务度假酒店有限公司',
				link: 'http://www.fairmont.cn/yangchenglake'
			},
			{
				name: '昆山乐建住房开发有限公司',
				link: 'javascript:;'
			},
			{
				name: '昆山文化艺术中心开发有限公司',
				link: 'http://www.kscac.com/'
			},
			{
				name: '昆山城投房产管理有限公司',
				link: 'javascript:;'
			}, {
				name: '昆山城投资产管理有限公司',
				link: 'javascript:;'
			}, {
				name: '昆山南部投资发展有限公司',
				link: 'javascript:;'
			}, {
				name: '昆山市建设工程管理有限公司',
				link: 'javascript:;'
			}, {
				name: '昆山亭林园绿化建设管理有限公司',
				link: 'https://www.tinglingarden.com/index.html'
			}, {
				name: '昆山市城市生态森林公园有限公司',
				link: 'http://www.ksforestpark.com/'
			}, {
				name: '昆山城建绿和环境科技有限公司',
				link: 'javascript:;'
			}, {
				name: '昆山城投古镇保护发展有限公司',
				link: 'javascript:;'
			}
			]
		}
	},
	created() {
		this.getSub()
	},
	methods: {
		goTo(e) {
			if (e.toOtherPageUrl) {
				window.location.href = e.toOtherPageUrl
				return
			}
			if (e.url === '/') {
				return
			}
			this.$router.push(e.url)
		},
		getSub() {
			let params = {
				pageNum: 1,
				pageSize: 100
			}
			sub(params).then(res => {
				console.log("获取下属子公司", res)
				this.dataList = res.data.records
			})
		}
	}
}
</script>

<style scoped lang="scss">
#FooterBox {
	// margin-top: 40px;
	background-color: #e6e6e6;

	.sub {
		height: 30px;
		font-weight: bold;
		// font-family: '微软雅黑';
		font-size: 14px;
		text-align: left;
	}

	.tips {
		font-size: 13px;
		height: 25px;
		line-height: 25px;
		// font-family: '微软雅黑';
		color: #666;
		text-align: left;
	}

	.top {
		padding-top: 20px;
		padding-bottom: 20px;
		display: flex;
		align-items: center;

		.left {
			width: 600px;

			.childer {
				display: flex;
				flex-wrap: wrap;

				.box_childer {
					width: 40%;
					// height: 25px;
					text-align: left;
				}

				a {
					// color: #666;
					// width: 100%;
					// font-size: 12px;
					// line-height: 25px;
					// justify-content:left;
					// cursor: pointer;

				}
			}
		}

		.right {
			display: flex;
		}
	}

	.bottom {
		width: 100%;
		min-width: 1100px;
		height: 30px;
		background: #cdcdcd;
		text-align: center;
		line-height: 30px;
		// font-family: '微软雅黑';
		font-size: 11px;
		color: #444;
	}

	.ba {
		font-size: 11px;
		color: #444;
		line-height: 30px;
		cursor: pointer;
	}

	.ba:hover {
		color: #F39801;
	}



}
</style>
